export default __webpack_public_path__ + "static/media/cover.293379b5.jpg";